export class Cycle {
    public id: string;
    public technicalCycleId: string;
    public from: Date;
    public to: Date;
    public exclusionZones: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: Cycle) {
        if (json) {
            this.id = json.id;
            this.technicalCycleId = json.technicalCycleId;
            this.from = json.from;
            this.to = json.to;
            this.exclusionZones = json.exclusionZones;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/cycle.ts